var map = {
	"./choose-your-weapon-vulcan.svg": 685,
	"./close-icon.svg": 981,
	"./lizard-circle.svg": 114,
	"./lizard.svg": 887,
	"./paper-circle.svg": 342,
	"./paper.svg": 65,
	"./play-some-games-vulcan.svg": 209,
	"./rock-circle.svg": 582,
	"./rock.svg": 395,
	"./rulezz-1.svg": 727,
	"./rulezz.svg": 782,
	"./scissors-circle.svg": 9,
	"./scissors.svg": 814,
	"./search-icon.svg": 355,
	"./spock-circle.svg": 724,
	"./spock.svg": 367,
	"./vulcan-head.svg": 850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;